import { AxiosResponse } from "axios";
import { Operator, UpdateOperatorOpts } from "../../../models/Api/Operator";
import { axiosInstance } from "../../../../../axiosInstance";

export const getOperator = async (): Promise<AxiosResponse<Operator>> => {
  return axiosInstance.get(`/operators`);
};

export const updateOperator = async ({
  ...payload
}: UpdateOperatorOpts): Promise<AxiosResponse<Operator>> => {
  return axiosInstance.put(`/operators`, payload);
};
